module.exports = __webpack_public_path__ + "static/media/pin.0530cfdc.svg";